export enum Journey {
  LOGIN = "password_and_otp_auth",
  FORGOT_PASSWORD = "forgot_password_userless",
  VERIFY_USER_REGISTRATION_EMAIL = "verify_user_registration_email_focus",
  COMPLETE_USER_REGISTRATION = "complete_user_registration",
  CHANGE_PASSWORD = "change_password",
  // RESET_CHALLENGE_QA = 'change_qa',
  // VALIDATE_CHALLENGE_QA = 'validate_challenge_qa',// For Reset Password Flow
  WELCOME_USER = "welcome_user",
  REGISTRATION_SUCCESS = "reg_success",
  // FORGOT_PASSWORD_ENTER_CHALLENGE_QA = 'forgot_password_user_based_challenge_qa',
}

export interface ClientContextObject {
  errorMessage?: string;
  username?: string;
  password?: string;
  uiContainer?: any;
  resolve?: (value: any | PromiseLike<any>) => void;
}

export interface ErrorMessages {
  CHALLENGE_QUESTIONS_LOCKED: string;
  PASSWORD_TOTAL_LENGTH_OUT_OF_RANGE: string;
  PASSWORD_DUP_SUBSTRING: string;
  PASSWORD_RECENTLY_USED: string;
  INVALID_CREDENTIALS: string;
  PASSWORD_NOT_ALLOWED_CHARS: string;
  PASSWORD_NUM_OF_RULES_MATCHED_BELOW_LIMIT: string;
  // PASSWORD_LOCKED: string;
  // ACCOUNT_INACTIVE: string;
  PWD_CORRECT_BUT_EXPIRED: string;

  [key: string]: string;
}

export interface PayloadObject {
  password_reset_status: { errors: { code: keyof ErrorMessages, message: string }[] };
  challenge_qa_reset_status: { errors: { code: keyof ErrorMessages, message: string }[] };
  challengeQuestions: { challengeQuestions: { id: string, question: string }[] };
  challengeQuestionAnswers: { questionId: string, question: string }[];
  email: string;
  header: string;
  subheader: string;
}
